import React, { useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { PostDocument } from '../../../dao/abp/PostDocument';

interface Props {
    visible: boolean;
    onClose: (refresh: boolean) => void;
    idProjecte: string;
}

const NouDocumentModal: React.FC<Props> = ({ visible, onClose, idProjecte }) => {
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setConfirmLoading(true);

            await PostDocument(idProjecte, values.nom, values.descripcio);

            message.success('Document creat correctament');
            form.resetFields();
            setConfirmLoading(false);
            onClose(true);
        } catch (error) {
            console.error(error);
            setConfirmLoading(false);
        }
    };

    return (
        <Modal
            title="Nou Document"
            open={visible}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={() => onClose(false)}
        >
            <Form
                form={form}
                layout="vertical"
                name="form_in_modal"
            >
                <Form.Item
                    name="nom"
                    label="Nom del Document"
                    rules={[{ required: true, message: 'Si us plau, introdueix el nom del document!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="descripcio"
                    label="Descripció (Contingut)"
                    rules={[{ required: true, message: 'Si us plau, introdueix la descripció!' }]}
                >
                    <Input.TextArea rows={4} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default NouDocumentModal;
